import FormPage from './formPage';
import FieldYesNo from './fields/fieldYesNo';
import FieldSelect from './fields/fieldSelect';
import FieldNumeric from './fields/fieldNumeric';
import FieldDate from './fields/fieldDate';
import FieldText from './fields/fieldText';
import Select from 'react-select'
import DatePicker from "react-datepicker";
import Sinistres from './sinistres'

export default class FrontAntecedents extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Vos antécédents'
        this.state = {
            showValidate:false
        }

    }


    next() {
//        if ( this.props.devis.params.comparateursCompleted || ! this.props.devis.params.MER ) {
        this.props.setPage('landing')
    }

    back() {
        this.props.setPage('vous')
    }


    renderAnnulation(container) {
        return <>
            <FieldDate field="ant_annulation_date" container={container} />
        </>
    }

    renderStupefiants(container) {
        return <>
            <FieldDate field="ant_stupefiants_date" container={container} />
            <FieldText field="ant_stupefiants_substance" container={container} />
            <FieldSelect field="ant_stupefiants_sinistre" container={container} />
            <FieldYesNo field="ant_stupefiants_recidive" container={container} />
        </>   
    }

    renderAlcool(container) {
        return <>
            <FieldDate field="ant_alcool_date" container={container} />
            <FieldSelect field="ant_alcool_taux" container={container} />
            <FieldSelect field="ant_alcool_sinistre" container={container} />
            <FieldYesNo field="ant_alcool_recidive" container={container} />
        </>
    }

    renderRetrait(container) {
        return <>
            <FieldDate field="ant_retrait_date" container={container} />
            <FieldNumeric field="ant_retrait_duree_mois" container={container} min="0" max="36" />
            <FieldSelect field="ant_retrait_motif_full" container={container} />
            <FieldYesNo field="ant_retrait_recidive" container={container} />
        </>
    }

    renderResiliation(container) {
        return <>
            <FieldDate field="ant_resiliation_date" container={container} />
            <FieldYesNo field="ant_resiliation_non_paiement" container={container}/>
            <FieldYesNo field="ant_resiliation_fausse_declaration" container={container}/>
            <FieldYesNo field="ant_resiliation_frequence_sinistres" container={container}/>
            <FieldYesNo field="ant_resiliation_autre_motif" container={container}/>
        </>   
    }


    onAddSinistre() {
        if ( !( this.state.typeAddSinistre && this.state.typeAddSinistre.value )) {
            alert('Choisissez le type de sinistre, la date du sinistre, puis cliquez sur "Ajouter"')
            return
        }
        if ( !this.state.dateAddSinistre ) {
            alert('Indiquez la date du sinistre, puis cliquez sur "Ajouter"')
            return
        }
        this.props.devis.addSinistre( this.state.typeAddSinistre.value, this.state.dateAddSinistre, this.state.vehiculeAddSinistre.value, this.props.changeParams )
        this.setState({typeAddSinistre:false,dateAddSinistre:'',vehiculeAddSinistre:''})
    }

    doRender(container) {
        const {type} = this.props
        const params = this.props.devis.params
        const noticeCondSecondaire = ( params.conducteur_2 == 'O' )?<>, <b>vous ou le conducteur secondaire, </b></>:<></>
        const noticePourCondSecondaire = ( params.conducteur_2 == 'O' )?<>, <b>pour vous ou le conducteur secondaire, </b></>:<></>
        return <>
            <div className="contentvbox">
            <h1 className="top_title">Retraits de permis</h1>

            <h3>Au cours des 36 derniers mois{noticeCondSecondaire} avez-vous fait l'objet&nbsp;:</h3>
            <FieldYesNo field="ant_retrait" container={container} />
            {( params.ant_retrait=='O' )? this.renderRetrait(container) : '' }
            </div>

            <div className="contentvbox">
            <h1 className="top_title">Annulation de permis</h1>

            <h3>Au cours des 36 derniers mois{noticeCondSecondaire} avez-vous fait l'objet&nbsp;:</h3>
            <FieldYesNo field="ant_annulation" container={container} />
            {( params.ant_annulation=='O' )? this.renderAnnulation(container) : '' }
            </div>

            <div className="contentvbox">
            <h1 className="top_title">Alcoolémie</h1>

            <h3>Au cours des 36 derniers mois{noticeCondSecondaire} avez-vous fait l'objet&nbsp;:</h3>
            <FieldYesNo field="ant_alcool" container={container} />
            {( params.ant_alcool=='O' )? this.renderAlcool(container) : '' }
            </div>

            <div className="contentvbox">
            <h1 className="top_title">Stupéfiants</h1>

            <h3>Au cours des 36 derniers mois{noticeCondSecondaire} avez-vous fait l'objet&nbsp;:</h3>
            <FieldYesNo field="ant_stupefiants" container={container} />
            {( params.ant_stupefiants=='O' )? this.renderStupefiants(container) : '' }
            </div>

            <div className="contentvbox">
            <h1 className="top_title">Résiliation d'assurance</h1>

            <h3>Au cours des 36 derniers mois{noticeCondSecondaire} avez-vous fait l'objet&nbsp;:</h3>
            <FieldYesNo field="ant_resiliation" container={container} />
            <i>(Pour un motif autre que ceux indiqués ci-dessus)</i>
            {( params.ant_resiliation=='O' )? this.renderResiliation(container) : '' }
            </div>

            <div className="contentvbox extrabottom">
            <h1 className="top_title">Sinistres</h1>

        <h3>Renseignez les sinistres survenus{noticePourCondSecondaire} au cours des 3 dernières années (36 derniers mois) {/*<u><b>avec ce véhicule</b></u>*/}</h3>

        <Sinistres container={container} />

        <h3>Ajouter un sinistre</h3>
        <div className="front_form_row">
            <Select placeholder="Type de sinistre"
                value={this.state.typeAddSinistre}
                options = {( type=='moto' )?FrontAntecedents.optionsTypeSinistre:FrontAntecedents.optionsTypeSinistreAuto }
                classNames = { FieldSelect.selectClassNames }
                onChange = {v => this.setState({typeAddSinistre:v}) }
            />
            <Select placeholder="Véhicule"
                value={this.state.vehiculeAddSinistre}
                options = {FrontAntecedents.optionsVehicules}
                classNames = { FieldSelect.selectClassNames }
                onChange = {v => this.setState({vehiculeAddSinistre:v}) }
            />
        </div>
        <div className="front_form_row">
            <DatePicker 
                selected={this.state.dateAddSinistre}
                placeholderText="Date du sinistre" 
                dateFormat="dd/MM/yyyy" isClearable showYearDropdown 
                onChange = {v => this.setState({dateAddSinistre:v}) }
                locale="fr" />
        </div>
        <div className="front_form_row">
            <button onClick={this.onAddSinistre.bind(this)} className="bluebutton">Ajouter</button>
        </div>
        </div>
        </>
    }
}


FrontAntecedents.optionsTypeSinistre = [
    { value:'nr',label:'Non responsable' },
    { value:'vi',label:'Vol, incendie' },
    { value:'mr',label:'Matériel responsable' },
    { value:'cr',label:'Corporel responsable' }
]

FrontAntecedents.optionsTypeSinistreAuto = [
    { value:'nr',label:'Non responsable' },
    { value:'vi',label:'Vol, incendie' },
    { value:'bg',label:'Bris de glace' },
    { value:'mr',label:'Matériel responsable' },
    { value:'cr',label:'Corporel responsable' }
]

FrontAntecedents.optionsVehicules = [
    { value:'AUTO', label:'Auto'},
    { value:'MOTO', label:'Moto'}
]